import { FormLoadingIndicator } from 'components/shared/FormLoadingIndicator/FormLoadingIndicator';
import { useAppSelector } from 'hooks/useAppSelector';
import { getAddonDescriptions } from 'state/product-description/selectors';
import styled from 'styled-components';

import { AddonManagementFormTable } from './AddonManagementFormTable';
import { AddonManagementToolbar } from './AddonManagementToolbar';

const StyledContainer = styled.div`
  overflow-y: hidden;
`;

export function AddonManagement(): React.JSX.Element {
  const productDescription = useAppSelector(getAddonDescriptions);

  if (!productDescription) {
    return <FormLoadingIndicator className="w-100" />;
  }

  return (
    <StyledContainer className="w-100 h-up-xl-100 min-h-down-lg-100 d-flex flex-column bg-lvl4">
      <AddonManagementToolbar />
      <AddonManagementFormTable productDescription={productDescription} />
    </StyledContainer>
  );
}
